<template>
  <div>
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('system.alert') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">
                {{ $t('button.dismiss') }}
              </v-btn>
              <v-btn color="red accent-4" class="white--text" @click="deleteFromDatabase">
                {{ $t('button.confirm') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-dialog v-model="dialog" max-width="1000">
      <v-card>
        <v-card-title>
          <span class="headline" style="color: #4a4a4a">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="formValidado">
              <!-- Dados do indicador -->
              <v-card class="pa-4 mb-4" outlined>
                <v-card-title class="text-h6 pa-0 mb-3 d-flex align-center justify-space-between">
                  <span>{{ $t('adjustmentIndicator.indicatorData') }}</span>
                  <v-switch
                    v-model="editedItem.ativo"
                    :label="$t('adjustmentIndicator.active')"
                    :true-value="1"
                    :false-value="0"
                    class="mt-0 pt-0"
                    hide-details
                  ></v-switch>
                </v-card-title>
                <v-divider class="mb-3"></v-divider>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field
                      v-model="editedItem.codigo"
                      :label="$t('adjustmentIndicator.code')"
                      :rules="[(v) => (!!v && v.length <= 50) || $t('adjustmentIndicator.codeRequired')]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="5">
                    <v-text-field
                      v-model="editedItem.nome"
                      :label="$t('adjustmentIndicator.name')"
                      :rules="[(v) => (!!v && v.length <= 100) || $t('adjustmentIndicator.nameRequired')]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-select
                      v-model="editedItem.tipo"
                      :items="tipoItems"
                      :label="$t('adjustmentIndicator.type')"
                      :rules="[(v) => !!v || $t('adjustmentIndicator.typeRequired')]"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedItem.descricao"
                      :label="$t('adjustmentIndicator.description')"
                      :rules="[(v) => !v || v.length <= 500]"
                      counter="500"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model.number="editedItem.periodicidade_meses"
                      type="number"
                      min="1"
                      max="120"
                      :label="$t('adjustmentIndicator.periodicityMonths')"
                      :hint="$t('adjustmentIndicator.periodicityHint')"
                      persistent-hint
                      :rules="[(v) => v === null || v === '' || (Number.isInteger(v) && v >= 1 && v <= 120) || $t('adjustmentIndicator.periodicityInvalid')]"
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.dt_referencia_reajuste"
                      type="date"
                      :label="$t('adjustmentIndicator.referenceDate')"
                      :rules="[(v) => !editedItem.periodicidade_meses || !!v || $t('adjustmentIndicator.referenceDateRequired')]"
                      clearable
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>

              <!-- Reajuste por ano -->
              <v-card class="pa-4" outlined>
                <v-card-title class="text-h6 pa-0 mb-1 d-flex align-center justify-space-between">
                  <span>{{ $t('adjustmentIndicator.valuesTitle') }}</span>
                  <v-btn small color="primary" @click="adicionaAno">
                    <v-icon left small>mdi-plus</v-icon>
                    {{ $t('adjustmentIndicator.addYear') }}
                  </v-btn>
                </v-card-title>
                <div class="text-caption grey--text mb-3">{{ $t('adjustmentIndicator.valuesHint') }}</div>
                <v-divider class="mb-3"></v-divider>
                <div v-if="!editedItem.valores.length" class="text-body-2 grey--text">
                  {{ $t('adjustmentIndicator.noValues') }}
                </div>
                <v-row v-for="(v, idx) in editedItem.valores" :key="v.uid" dense align="center">
                  <v-col cols="6" sm="2">
                    <v-text-field
                      v-model.number="v.ano"
                      type="number"
                      :label="$t('adjustmentIndicator.year')"
                      :rules="[anoRule]"
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="2">
                    <v-text-field
                      v-model="v.percentual"
                      type="number"
                      step="0.0001"
                      suffix="%"
                      :label="$t('adjustmentIndicator.percent')"
                      :rules="[(x) => (x !== null && x !== '') || $t('adjustmentIndicator.percentRequired')]"
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="3">
                    <v-text-field
                      v-model="v.dt_base"
                      type="date"
                      :label="$t('adjustmentIndicator.baseDate')"
                      clearable
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="5" sm="4">
                    <v-text-field
                      v-model="v.observacao"
                      :label="$t('adjustmentIndicator.observation')"
                      :rules="[(x) => !x || x.length <= 255]"
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="1" class="text-right">
                    <v-btn icon small color="red" @click="removeAno(idx)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-4" class="white--text" @click="close">
            {{ $t('button.cancel') }}
          </v-btn>
          <v-btn color="primary darken-1" class="white--text" :loading="salvando" @click="save">
            {{ $t('button.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container max-width="100%" style="margin-top: 2%">
      <merus-data-table
        :headers="headers"
        :items="indicadores"
        :loading="loadingtable"
        :loading-text="$t('adjustmentIndicator.loading')"
        :default-multi-sort="defaultSort"
        :server-items-length="totalIndicadores"
        :items-per-page="numberOfRows"
        :items-per-page-last-option="itemsPerPageLastOption"
        :server-sort-by="serverSortBy"
        :server-sort-desc="serverSortDesc"
        @update:options="onTableOptions"
        @update:filters="onFiltersUpdate"
        cod-tabela="INDICADORESREAJUSTE"
        @update:headers="headers = $event"
      >
        <template v-slot:toolbar>
          <cadastro-toolbar
            :title="$t('adjustmentIndicator.title')"
            :token="token"
            :items="indicadores"
            :load-items-for-export="loadItemsForExport"
            background-export
            list-endpoint="subsidio/getallindicadoresreajuste"
            :export-filters="searchFilters"
            :export-sort-by="serverSortBy"
            :export-sort-desc="serverSortDesc"
            :export-total="totalIndicadores"
            id-field="id_indicador"
            :csv-title="$t('adjustmentIndicator.title')"
            :csv-headers="headers"
            :pdf-title="$t('adjustmentIndicator.title')"
            :pdf-headers="headers"
            :pdf-filename="$t('adjustmentIndicator.title')"
            hide-search
          >
            <template v-slot:extension>
              <v-switch
                v-model="mostrarInativos"
                :label="$t('crudVeiculos.showInactive')"
                class="ml-3 mr-4"
                hide-details
              ></v-switch>
            </template>
            <template v-slot:add v-if="canInsert">
              <v-btn color="primary" dark small class="mb-2" fab @click="openNewItem">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
          </cadastro-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="mr-2"
            color="red"
            @click="deleteItem(item)"
            :disabled="item.ativo == 0 || !canDelete"
          >mdi-delete</v-icon>
        </template>
      </merus-data-table>
    </v-container>
  </div>
</template>

<script>
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import serverTableMixin from '@/mixins/serverTableMixin';
import {
  buildRequestParams,
  computePageState,
  initSortFromDefault,
  fetchAllServerPagesForExport,
} from '@/utils/serverTablePagination';

const TIPOS = ['IMPOSTO', 'COMBUSTIVEL', 'DISSIDIO', 'OUTRO'];

/**
 * Cadastro dos indicadores de reajuste anual de valor (impostos, combustível,
 * dissídio...). Cada indicador tem um percentual por ano, editado no mesmo
 * formulário e gravado junto com ele. A exclusão só desativa: o histórico de
 * anos fica no cadastro.
 */
export default {
  name: 'CRUDIndicadoresReajuste',
  mixins: [serverTableMixin],
  components: { MerusDataTable, CadastroToolbar },
  data: () => ({
    headers: [
      { text: 'Código', value: 'codigo' },
      { text: 'Nome', value: 'nome' },
      { text: 'Tipo', value: 'tipo_extenso' },
      { text: 'Descrição', value: 'descricao' },
      { text: 'Último ano', value: 'ultimo_ano' },
      { text: 'Último reajuste (%)', value: 'ultimo_percentual' },
      { text: 'Ativo', value: 'ativo_extenso' },
    ],
    user: null,
    token: null,
    loadingtable: false,
    salvando: false,
    formValidado: true,
    dialog: false,
    confirmDialog: false,
    mensagemdialog: '',
    mostrarInativos: false,

    indicadores: [],
    totalIndicadores: 0,
    numberOfRows: 10,
    itemsPerPageLastOption: 250,
    lastItemsPerPageBeforeTodos: null,
    pageNumber: 1,
    serverSortBy: [],
    serverSortDesc: [],
    searchFilters: { ativo: 1 },

    canInsert: false,
    canEdit: false,
    canDelete: false,

    editedIndex: -1,
    editedItem: null,
    deletedItem: null,
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('adjustmentIndicator.newIndicator')
        : this.$t('adjustmentIndicator.editIndicator');
    },
    tipoItems() {
      return TIPOS.map((t) => ({ value: t, text: this.$t('adjustmentIndicator.types.' + t) }));
    },
    defaultSort() {
      return [{ value: 'nome', options: { text: this.$t('routs.increasing'), value: 1 } }];
    },
  },
  watch: {
    mostrarInativos() {
      // eslint-disable-next-line no-unused-vars
      const { ativo, ...colunas } = this.searchFilters;
      this.searchFilters = { ...colunas, ...this.serverTableBaseFilters() };
      this.pageNumber = 1;
      this.serverTableLoad();
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.token = sessionStorage.getItem('api');
    this.editedItem = this.itemVazio();
    this.deletedItem = this.itemVazio();
    this._uid_ano = 0;
    const { serverSortBy, serverSortDesc } = initSortFromDefault(this.defaultSort);
    this.serverSortBy = serverSortBy;
    this.serverSortDesc = serverSortDesc;
    this.populaRecursos();
    this.serverTableLoad();
  },
  methods: {
    // Sem "mostrar inativos", só os ativos.
    serverTableBaseFilters() {
      return this.mostrarInativos ? {} : { ativo: 1 };
    },
    itemVazio() {
      return {
        id_indicador: null,
        codigo: null,
        nome: null,
        tipo: null,
        descricao: null,
        periodicidade_meses: null,
        dt_referencia_reajuste: null,
        ativo: 1,
        valores: [],
      };
    },
    proximoUid() {
      this._uid_ano += 1;
      return this._uid_ano;
    },
    anoRule(v) {
      const n = Number(v);
      return (Number.isInteger(n) && n >= 1900 && n <= 2200) || this.$t('adjustmentIndicator.yearRequired');
    },
    formataPercentual(valor) {
      if (valor == null || valor === '') return null;
      return Number(valor).toLocaleString(this.$i18n.locale, { maximumFractionDigits: 4 });
    },
    mapParaExibicao(rows) {
      return (rows || []).map((r) => ({
        ...r,
        tipo_extenso: this.$t('adjustmentIndicator.types.' + (TIPOS.includes(r.tipo) ? r.tipo : 'OUTRO')),
        ultimo_percentual: this.formataPercentual(r.ultimo_percentual),
        ativo_extenso: r.ativo == 1 ? this.$t('system.yes') : this.$t('system.no'),
      }));
    },

    // ----- listagem -------------------------------------------------------

    serverTableLoad(options) {
      const state = {
        pageNumber: this.pageNumber,
        numberOfRows: this.numberOfRows,
        serverSortBy: this.serverSortBy,
        serverSortDesc: this.serverSortDesc,
        searchFilters: this.searchFilters,
        lastItemsPerPageBeforeTodos: this.lastItemsPerPageBeforeTodos,
        total: this.totalIndicadores,
      };
      const { params, page, rowsPerPage, sortByArr, sortDescArr } = buildRequestParams(options, state);
      this.loadingtable = true;
      return apiController
        .request(apiController.endpoints.subsidioGetallIndicadoresreajuste, {
          data: params,
          onSuccess: (response) => {
            const data = response.data;
            if (data && typeof data.total === 'number' && Array.isArray(data.items)) {
              this.indicadores = this.mapParaExibicao(data.items);
              const updates = computePageState(
                data,
                { page, rowsPerPage, sortByArr, sortDescArr },
                state,
                this.itemsPerPageLastOption,
              );
              this.totalIndicadores = updates.total;
              this.pageNumber = updates.pageNumber;
              this.numberOfRows = updates.numberOfRows;
              this.lastItemsPerPageBeforeTodos = updates.lastItemsPerPageBeforeTodos;
              this.serverSortBy = updates.serverSortBy;
              this.serverSortDesc = updates.serverSortDesc;
            } else {
              this.indicadores = this.mapParaExibicao(Array.isArray(data) ? data : []);
              this.totalIndicadores = this.indicadores.length;
            }
          },
        })
        .catch(() => {})
        .finally(() => {
          this.loadingtable = false;
        });
    },
    loadItemsForExport(onProgress) {
      return fetchAllServerPagesForExport({
        fetchPage: async (params) => {
          const response = await apiController.request(
            apiController.endpoints.subsidioGetallIndicadoresreajuste,
            { data: params, silent: true },
          );
          return response && response.data;
        },
        state: {
          total: this.totalIndicadores,
          serverSortBy: this.serverSortBy,
          serverSortDesc: this.serverSortDesc,
          searchFilters: this.searchFilters,
        },
        mapItems: (items) => this.mapParaExibicao(items),
        onProgress,
      });
    },
    populaRecursos() {
      const superadmin = this.user.is_superadmin === 1;
      const endpoint = superadmin
        ? apiController.endpoints.getallRecursos
        : apiController.endpoints.getRecursosusuario;
      const opcoes = {
        onSuccess: (response) => {
          const recursos = response.data || [];
          const tem = (rota) => recursos.some((r) => r.rota === rota);
          this.canEdit = superadmin || tem('/api/v1.0/subsidio/updateindicadorreajuste');
          this.canInsert = superadmin || tem('/api/v1.0/subsidio/insertindicadorreajuste');
          this.canDelete = superadmin || tem('/api/v1.0/subsidio/deleteindicadorreajuste');
        },
      };
      if (!superadmin) opcoes.params = { id: this.user.id_usuario };
      return apiController.request(endpoint, opcoes).catch(() => {});
    },

    // ----- anos -----------------------------------------------------------

    adicionaAno() {
      const anos = this.editedItem.valores.map((v) => Number(v.ano)).filter(Number.isFinite);
      const ano = anos.length ? Math.max(...anos) + 1 : new Date().getFullYear();
      // Mais recente primeiro, como vem do servidor.
      this.editedItem.valores.unshift({
        uid: this.proximoUid(),
        ano,
        percentual: null,
        dt_base: null,
        observacao: null,
      });
    },
    removeAno(idx) {
      this.editedItem.valores.splice(idx, 1);
    },

    // ----- abertura / fechamento ------------------------------------------

    openNewItem() {
      this.editedItem = this.itemVazio();
      this.editedIndex = -1;
      this.dialog = true;
    },
    async editItem(item) {
      try {
        const response = await apiController.request(
          apiController.endpoints.subsidioGetIndicadorreajuste,
          { params: { id: item.id_indicador }, silent: true },
        );
        const t = response.data;
        this.editedIndex = this.indicadores.findIndex((x) => x.id_indicador === t.id_indicador);
        this.editedItem = {
          id_indicador: t.id_indicador,
          codigo: t.codigo,
          nome: t.nome,
          tipo: t.tipo,
          descricao: t.descricao,
          periodicidade_meses: t.periodicidade_meses == null ? null : Number(t.periodicidade_meses),
          dt_referencia_reajuste: t.dt_referencia_reajuste || null,
          ativo: t.ativo == 1 ? 1 : 0,
          valores: (t.valores || []).map((v) => ({
            uid: this.proximoUid(),
            ano: v.ano,
            percentual: v.percentual == null ? null : Number(v.percentual),
            dt_base: v.dt_base || null,
            observacao: v.observacao,
          })),
        };
        this.dialog = true;
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      }
    },
    close() {
      this.dialog = false;
      if (this.$refs.form && typeof this.$refs.form.resetValidation === 'function') {
        this.$refs.form.resetValidation();
      }
      this.$nextTick(() => {
        this.editedItem = this.itemVazio();
        this.editedIndex = -1;
      });
    },

    // ----- gravação -------------------------------------------------------

    anoRepetido() {
      const vistos = new Set();
      for (const v of this.editedItem.valores) {
        const ano = Number(v.ano);
        if (vistos.has(ano)) return ano;
        vistos.add(ano);
      }
      return null;
    },
    async save() {
      this.$refs.form.validate();
      if (!this.formValidado) return;
      const repetido = this.anoRepetido();
      if (repetido != null) {
        EventBus.$emit('show-alert', {
          mensagem: this.$t('adjustmentIndicator.duplicateYear', { year: repetido }),
          tipo: 'error',
        });
        return;
      }

      this.salvando = true;
      const criando = this.editedIndex === -1 && !this.editedItem.id_indicador;
      try {
        const endpoint = criando
          ? apiController.endpoints.subsidioInsertIndicadorreajuste
          : apiController.endpoints.subsidioUpdateIndicadorreajuste;
        const response = await apiController.request(endpoint, {
          data: {
            id_indicador: this.editedItem.id_indicador,
            codigo: this.editedItem.codigo,
            nome: this.editedItem.nome,
            tipo: this.editedItem.tipo,
            descricao: this.editedItem.descricao,
            periodicidade_meses: this.editedItem.periodicidade_meses || null,
            dt_referencia_reajuste: this.editedItem.dt_referencia_reajuste || null,
            ativo: this.editedItem.ativo,
            valores: this.editedItem.valores.map((v) => ({
              ano: v.ano,
              percentual: v.percentual,
              dt_base: v.dt_base || null,
              observacao: v.observacao,
            })),
          },
          silent: true,
        });
        if (response.data && response.data.erro) {
          EventBus.$emit('show-alert', { mensagem: response.data.mensagem, tipo: 'error' });
          return;
        }
        EventBus.$emit('show-alert', { mensagem: this.$t('adjustmentIndicator.saved'), tipo: 'success' });
        this.close();
        this.serverTableLoad();
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      } finally {
        this.salvando = false;
      }
    },

    // ----- exclusão (desativa) --------------------------------------------

    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.mensagemdialog = this.$t('adjustmentIndicator.confirmDelete', { code: item.codigo });
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      apiController
        .request(apiController.endpoints.subsidioDeleteIndicadorreajuste, {
          data: { id_indicador: this.deletedItem.id_indicador },
          onSuccess: () => {
            this.confirmDialog = false;
            EventBus.$emit('show-alert', {
              mensagem: this.$t('adjustmentIndicator.deleted'),
              tipo: 'success',
            });
            this.serverTableLoad();
          },
          onError: () => {
            this.confirmDialog = false;
          },
        })
        .catch(() => {});
    },
  },
};
</script>
